var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Paper from '@material-ui/core/Paper';
import styled from 'styled-components';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  & > *,\n  & .MuiPaper-root {\n    padding: 1rem;\n    background-color: #f7f8f9;\n    width: 100%;\n  }\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  & > *,\n  & .MuiPaper-root {\n    padding: 1rem;\n    background-color: #f7f8f9;\n    width: 100%;\n  }\n"])));
var PaymentCardContainer = function (props) {
    return (React.createElement(Wrapper, null,
        React.createElement(Paper, __assign({}, props, { elevation: 1 }))));
};
export default PaymentCardContainer;
var templateObject_1;
